module.exports = __webpack_public_path__ + "static/img/10.0729b38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/10.png
// module id = kL8E
// module chunks = 0